export default __webpack_public_path__ + "static/SRUS STDXX - Especification Del Producto y Datos Técnicos-e26b6d1cc4c2b60a7690b676d79867b1.pdf";